/* ===========================
   Fabric Love - Member Area
   - Renders active member offers from window.FL_OFFERS
   - Uses <picture> for responsive desktop/mobile images
   - Overlays offer text block and Shop Now button on image
   - Can optionally restrict visibility to verified members
   =========================== */

(function () {
  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isVerifiedMember() {
    return !!(
      window.FLMember &&
      typeof window.FLMember.isVerifiedMember === 'function' &&
      window.FLMember.isVerifiedMember()
    );
  }

  function getOffers() {
    if (!Array.isArray(window.FL_OFFERS)) return [];

    return window.FL_OFFERS.filter(function (offer) {
      return !!(
        offer &&
        offer.enabled &&
        offer.appliedLink &&
        offer.appliedLinkText &&
        offer.memberAreaImageDesktop
      );
    });
  }

  function renderOfferCard(offer) {
    var desktopImage = offer.memberAreaImageDesktop || '';
    var mobileImage = offer.memberAreaImageMobile || desktopImage;
    var offerText = offer.appliedLinkText || '';
    var link = offer.appliedLink || '#';
    var key = offer.key || '';

    return `
      <article class="fl-member-area-card" data-offer-key="${escapeHtml(key)}">
        <a class="fl-member-area-card__link" href="${escapeHtml(link)}">
          <div class="fl-member-area-card__media">
            <picture class="fl-member-area-card__picture">
              <source
                media="(max-width: 767px)"
                srcset="${escapeHtml(mobileImage)}"
              >
              <img
                class="fl-member-area-card__image"
                src="${escapeHtml(desktopImage)}"
                alt="${escapeHtml(offerText)}"
                loading="lazy"
              >
            </picture>

            <div class="fl-member-area-card__overlay">
              <div class="fl-member-area-card__text-block">
                ${escapeHtml(offerText)}
              </div>

              <span class="fl-member-area-card__button">
                Shop Now
              </span>
            </div>
          </div>
        </a>
      </article>
    `.trim();
  }

  function renderMemberArea() {
    var mounts = document.querySelectorAll('[data-fl-member-area]');
    if (!mounts.length) return;

    var offers = getOffers();

    mounts.forEach(function (mount) {
      var membersOnly = mount.getAttribute('data-members-only') === 'true';

      if (membersOnly && !isVerifiedMember()) {
        mount.innerHTML = '';
        mount.style.display = 'none';
        return;
      }

      if (!offers.length) {
        mount.innerHTML = '';
        mount.style.display = 'none';
        return;
      }

      mount.innerHTML = `
        <div class="fl-member-area-grid">
          ${offers.map(renderOfferCard).join('\n')}
        </div>
      `.trim();

      mount.style.display = 'block';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    renderMemberArea();
  });

  window.addEventListener('fl_member_state_changed', function () {
    renderMemberArea();
  });
})();